const NotShow = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-not-show"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m17.5,11c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5,6.5-2.916,6.5-6.5-2.916-6.5-6.5-6.5Zm0,12c-3.032,0-5.5-2.468-5.5-5.5s2.468-5.5,5.5-5.5,5.5,2.468,5.5,5.5-2.468,5.5-5.5,5.5Zm2.697-7.49l-1.99,1.99,1.99,1.99-.707.707-1.99-1.99-1.99,1.99-.707-.707,1.99-1.99-1.99-1.99.707-.707,1.99,1.99,1.99-1.99.707.707Zm3.803-5.523v2.042c-.305-.362-.64-.696-1-1.003v-1.039c0-.517-.242-1.015-.648-1.333,0,0,0,0,0,0h0S13.041,1.359,13.041,1.359c-.613-.48-1.469-.48-2.082,0L1.649,8.653c-.407.317-.649.815-.649,1.333v13.014h10.026c.306.36.641.695,1.003,1H0v-14.014c0-.835.377-1.607,1.033-2.12L10.342.572c.977-.766,2.34-.766,3.316,0l9.31,7.294c.646.506,1.032,1.298,1.032,2.12Z" />
    </svg>
  );
};

export default NotShow;
